export const AllocatedOptions = [
  { id: 1, text: "تخصیص شده" },
  { id: 0, text: "تخصیص نشده" },
];

export const PriorotyTypeOptions = [
  { id: 0, text: "فورس ماژور" },
  { id: 1, text: "معمولی" },
];

export const PickupstatusOptions = [
  { id: 0, text: "در انتظار جمع آوری" },
  { id: 1, text: "جمع آوری موفق" },
  { id: 2, text: "عدم جمع آوری موفق" },
  { id: 3, text: "غیر قابل جمع آوری" },
  { id: 4, text: "لغو شده" },
];

export const DeliveryStatusOptions = [
  {
    id: 0,
    text: "در انتظار توزیع",
  },
  {
    id: 1,
    text: "در حال توزیع",
  },
  {
    id: 2,
    text: "توزیع شده",
  },
  {
    id: 3,
    text: "توزیع نشده",
  },
];

export const PickupstatusMapOptions = [
  { id: 0, text: "تخصیص به منطقه " },
  { id: 1, text: "تخصیص به راننده " },
  { id: 2, text: "جمع آوری شده" },
  { id: 3, text: "عدم جمع آوری موفق" },
  { id: 4, text: "غیر قابل جمع آوری" },
  { id: 5, text: "لغو شده" },
];

export const deliveryStatusMapOptions = [
  { id: 0, text: "تخصیص به منطقه " },
  { id: 1, text: "تخصیص به راننده " },
  { id: 2, text: "جمع آوری شده" },
  { id: 3, text: "عدم جمع آوری موفق" },
  { id: 4, text: "غیر قابل جمع آوری" },
  { id: 5, text: "لغو شده" },
];

export const PickupKindOptions = [
  { id: 1, text: "مشتری " },
  { id: 0, text: "هاب" },
];

export const DutyKindOptions = [
  { id: 0, text: "جمع آوری" },
  { id: 1, text: "توزیع " },
  { id: 2, text: " مبادله" },
];

export const KindOptions = [
  { id: 0, text: "موتور سیکلت" },
  { id: 1, text: " وانت" },
  { id: 2, text: "کامیونت " },
];

export const VehicleStatusOptions = [
  { id: 0, text: "آماده بکار" },
  { id: 1, text: " تخصیص شده" },
  { id: 2, text: "غیرقابل بهره برداری" },
];

export const GetReadyOptions = [
  { id: 2, text: "غیر قابل بهره ورداری" },
  { id: 0, text: "آماده بکار" },
];

export const ServiceTypeOptions = [
  { id: 0, text: "پایه" },
  { id: 1, text: "تکمیلی" },
];

export const CnDirectionOptions = [
  { id: 0, text: "به جلو" },
  { id: 1, text: "برگشتی" },
];

export const CategoryTypeOptions = [
  { id: 0, text: "استاندارد" },
  { id: 1, text: "سفارشی" },
];

export const paymentType = [
  { id: 0, text: "پیش کرایه"},
  { id: 1, text: "کل فاکتور" , isDisabled: true },
];
export const booleanOption = [
  { id: true, text: "بله" },
  { id: false, text: "خیر" },
];
export const invoiceOption = [
  { id: true, text: "در انتظار پرداخت" },
  { id: false, text: "تسویه شده" },
];

export const paymentStatusOption = [
  { id: 0, text: "تسویه شده" },
  { id: 1, text: "تسویه نشده" },
];

export const paymentTypeOption = [
  { id: 0, text: "پس کرایه" },
  { id: 1, text: "پس کرایه و هزینه کالا" },
  { id: 2, text: "هزینه کالا" },
];
